// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__oz_Ue","validationTips":"StatementDescriptor_validationTips__3Dkoy"};